angular.module('data-ng-todos').decorator('TaskStatusEnum', ($delegate: any) => {
  $delegate.ACTIVE.value.stateName = 'upcoming';
  $delegate.COMPLETED.value.stateName = 'completed';
  $delegate.DISMISSED.value.stateName = 'hidden';
  $delegate.OVERDUE.value.stateName = 'overdue';
  $delegate.REMINDER.value.stateName = 'reminder';

  return $delegate;
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/decorators/task_status_enum_decorator.ts